import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center bg-white shadow-none rounded-lg overflow-hidden w-full hover:scale-110" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "text-xl font-semibold mb-2" }




export default /*#__PURE__*/_defineComponent({
  __name: 'CardComponent',
  props: {
  imageSrc: String,
  cardTitle: String,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: require(`@/assets/services/${props.imageSrc}`),
      alt: "services",
      class: "w-1/2 object-cover"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(props.cardTitle), 1)
    ])
  ]))
}
}

})